import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import LinesEllipsis from 'react-lines-ellipsis';
import AttachedContent from '../../components/AttachedContent/AttachedContent';
import AuthorBlock from '../../components/User/AuthorBlock';
import paths from '../../paths';
import ContentPreloader from '../../components/Preloader/ContentPreloader';
import { getVimeoPreview } from '../../utils/api/services/contest';

export default class PracticeCard extends Component {
  static propTypes = {
    practice: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      clamped: false,
      url: props.practice.vimeoPreviewUrl,
    };
  }

  handleReflow = (state) => {
    const { clamped, text } = state;
    // установить state только 1 раз, если произошло обрезание
    if (clamped !== true || this.state.clamped === true) return;
    this.setState({
      clamped: true,
    });
  };

  getVimeoUrl = (vimeoVideoId) => {
    getVimeoPreview(vimeoVideoId)
      .then((result) => {
        this.setState({ url: result });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  componentWillMount = () =>
      this.getVimeoUrl(this.props.practice.vimeoVideoId);

  render() {
    const { url } = this.state;
    const { practice } = this.props;
    const linkToDetail = `${paths.advocates.practiceCase}/${practice.alias}`;
    return (
      <div key={practice.id} className="card-item">
        <div className="card-media">
          <ContentPreloader />
          <AttachedContent
            vimeoVideoId={practice.vimeoVideoId}
            isPreview
            vimeoPreviewUrl={url}
            className="card-img"
            alt={practice.title}
            to={linkToDetail}
          />
          {practice.inContest && <div className="card-note">Участвует в голосовании</div>}
        </div>
        <div className="card-main">
          <Link to={linkToDetail} className="card-title">
            {practice.title}
          </Link>
          <div className="card-desc">
            <LinesEllipsis
              text={practice.description}
              maxLine="5"
              ellipsis="..."
              trimRight
              basedOn="letters"
              onReflow={this.handleReflow}
            />
            {this.state.clamped && (
              <Link to={linkToDetail} className="btn -more">
                {'Читать далее'}
              </Link>
            )}
          </div>
        </div>
    
        <div className="card-footer">
          <AuthorBlock
            user={practice.author}
            dateFormat="short"
            createDate={practice.createdDate}
            className=""
          />
            <div className="card-social">
              {practice.totalLikes != 0 && (
                <span className="card-social-item">
                  <img
                    src="/Content/images/icons/like.svg"
                    className="card-social-icon -like"
                    alt="Лайков"
                  />
                  {` ${practice.totalLikes}`}
                </span>
              )}
    
              {practice.totalComments != 0 && (
                <span className="card-social-item">
                  <img
                    src="/Content/images/icons/comments.svg"
                    className="card-social-icon"
                    alt="Комментариев"
                  />
                  {` ${practice.totalComments}`}
                </span>
              )}
            </div>
        </div>
      </div>
    );
  }
}
